import GenericTemplate from "../Common/GenericTemplate";

// the sub-path and sub-components mapping are in src/Config/routes.js
const Template = () => {
  const menuItems = [
    { label: "Upload", icon: "pi pi-upload", path: "upload" },
    { label: "History", icon: "pi pi-file", path: "uploadhistory" },
  ];

  return <GenericTemplate menuItems={menuItems} />;
};

export default Template;